import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  private showCookieNotice = false;
  constructor() { }

  ngOnInit() {
    // Read cookies
    if (document.cookie.indexOf('cookie-agreement') === -1) {
      this.showCookieNotice = true;
    }
  }

  acceptCookie() {
    this.setCookie('cookie-agreement', new Date().toISOString(), 1000);
    this.showCookieNotice = false;
  }

  private setCookie(name: string, value: string, expireDays: number, path = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + '; ' + expires + (path.length > 0 ? '; path=' + path : '');
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/header/header.component.ts